import type {PunishmentTemplateTranslationKeySerializer} from "@/generated/Punishment";
import {useGenericInfiniteQuery} from "@/hooks/useQueryHooks";
import {INITIAL_TEMPLATE_STATE} from "@/store/constants";
import type {TPunishmentType} from "@/store/types";
import {isUnverifiedType} from "@/utils/disciplineUtils";
import {uniqBy} from "lodash";

export const PUNISHMENT_KEYS = {
  mPunishment: ["/punishments/"],
  mPunishmentTemplates: ["/punishments/template/"],
  mUpdatePunishment: (id: number) => [`/punishments/${id}`],
  qPunishment: (id: number) => [`/punishments/${id}`],
  qPunishments: (userId: number) => [`/punishments/?user_id=${userId}`],
  qPunishmentTemplates: (punishmentType: TPunishmentType | "UNVERIFIED") => [
    `/punishments/template/?punishment_type=${punishmentType}`,
  ],
};

export const usePunishmentTemplateQuery = (punishmentType?: TPunishmentType) =>
  useGenericInfiniteQuery<PunishmentTemplateTranslationKeySerializer>({
    queryKey: PUNISHMENT_KEYS.qPunishmentTemplates(isUnverifiedType(punishmentType!) ? "UNVERIFIED" : punishmentType!),
    enabled: !!punishmentType,
    select: response =>
      uniqBy(
        [
          {
            ...INITIAL_TEMPLATE_STATE,
            punishment_type: punishmentType!,
          },
          ...response?.pages.flatMap(page => page.data.results),
        ],
        "id",
      ),
  });
